// extracted by mini-css-extract-plugin
export default {"hr":"hr_d0aKzV8","subsection":"subsection_lZ0KQe6"};